import { useAnalyticsEmitter } from '@utils/analytics/emitter';
import { useCallback } from 'react';

import { EnquiryFormScreen } from '../../features/enquiry/containers/EnquiryFormScreen';
import { ApiEnquiryGateway } from '../../features/enquiry/gateways/ApiEnquiryGateway';
import { useFlow } from '../../providers/FlowProvider';
import { ProductPurchaseDetails } from '../../types/Purchasing';

const enquiryGateway = new ApiEnquiryGateway();

export const EnquiryForm = ({
  product,
  purchasingDetails,
}: {
  product: ProductType;
  purchasingDetails?: ProductPurchaseDetails | null;
}) => {
  const [emitter] = useAnalyticsEmitter();

  const { goToStep } = useFlow();

  const handleSubmit = useCallback(() => {
    emitter('', 'submit');
  }, [emitter]);

  const handleSuccess = useCallback(() => {
    emitter('', 'success');
    goToStep('success');
  }, [emitter, goToStep]);

  return (
    <div className="px-6 pb-6">
      <EnquiryFormScreen
        enquiryGateway={enquiryGateway}
        hideTitle
        location="product page"
        onSubmit={handleSubmit}
        onSuccess={handleSuccess}
        product={product}
        productPrice={purchasingDetails?.price}
        productPurchaseDetails={purchasingDetails || undefined}
        source="PRODUCT_PAGE"
      />
    </div>
  );
};
